
import Button from "@/components/base/Button"

export default {
    name: "CookieConsentButton",
    components: {
        Button,
    },
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
    methods: {
        showCookieConsent() {
            this.$store.dispatch("cookie/showCookieConsent", true)
            this.$store.dispatch("cookie/showCookieSettings", true)
        },
    },
}
